import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { NotificationManager } from "../../components/common/react-notifications";
import apiAuth from "../../helpers/ApiAuth";

import {
  EMPLOYEE_LOG_REPORT,
  EMPLOYEE_LOG_REPORT_SUCCESS,
  EMPLOYEE_LOG_REPORT_ERROR,
  GET_EMPLOYEE_LOG_LIVE,
  GET_EMPLOYEE_LOG_LIVE_SUCCESS,
  GET_EMPLOYEE_LOG_LIVE_ERROR,
  GET_VISITOR_LOG_LIVE,
  GET_VISITOR_LOG_LIVE_SUCCESS,
  GET_VISITOR_LOG_LIVE_ERROR,
  PEOPLE_COUNT_LOG_REPORT,
  PEOPLE_COUNT_LOG_REPORT_SUCCESS,
  PEOPLE_COUNT_LOG_REPORT_ERROR,
  PEOPLE_TRACK_LOG_REPORT,
  PEOPLE_TRACK_LOG_REPORT_SUCCESS,
  PEOPLE_TRACK_LOG_REPORT_ERROR,
  PEOPLE_COUNT_DASH,
  PEOPLE_COUNT_DASH_SUCCESS,
  PEOPLE_COUNT_DASH_ERROR,
  VEHICLE_COUNT_LOG_REPORT,
  VEHICLE_COUNT_LOG_REPORT_SUCCESS,
  VEHICLE_COUNT_LOG_REPORT_ERROR,
  VEHICLE_COUNT_DASH,
  VEHICLE_COUNT_DASH_SUCCESS,
  VEHICLE_COUNT_DASH_ERROR,
  PEOPLE_OCCUPANCY_LOG_REPORT,
  PEOPLE_OCCUPANCY_LOG_REPORT_SUCCESS,
  PEOPLE_OCCUPANCY_LOG_REPORT_ERROR,
  AGE_GENDER_LOG_REPORT,
  AGE_GENDER_LOG_REPORT_SUCCESS,
  AGE_GENDER_LOG_REPORT_ERROR,
  ANPR_REPORT,
  ANPR_REPORT_SUCCESS,
  ANPR_REPORT_ERROR,
  ADD_ANPR_REPORT,
  ADD_ANPR_REPORT_SUCCESS,
  ADD_ANPR_REPORT_ERROR,
  UPDATE_ANPR_REPORT,
  UPDATE_ANPR_REPORT_SUCCESS,
  UPDATE_ANPR_REPORT_ERROR,
  ANPR_LIVE_REPORT,
  ANPR_LIVE_REPORT_SUCCESS,
  ANPR_LIVE_REPORT_ERROR,
  ANPR_SEARCH_REPORT,
  ANPR_SEARCH_REPORT_SUCCESS,
  ANPR_SEARCH_REPORT_ERROR,
  VEHICLE_LIVE_PARKING,
  VEHICLE_LIVE_PARKING_SUCCESS,
  VEHICLE_LIVE_PARKING_ERROR,
  PARKING_LOG_REPORT,
  PARKING_LOG_REPORT_SUCCESS,
  PARKING_LOG_REPORT_ERROR,
  PEOPLE_OCCUPANCY_DASH,
  PEOPLE_OCCUPANCY_DASH_SUCCESS,
  PEOPLE_OCCUPANCY_DASH_ERROR,
  AGE_GENDER_DASH,
  AGE_GENDER_DASH_SUCCESS,
  AGE_GENDER_DASH_ERROR,
  ANPR_DASH,
  ANPR_DASH_SUCCESS,
  ANPR_DASH_ERROR,
  PARKING_DASH,
  PARKING_DASH_SUCCESS,
  PARKING_DASH_ERROR,
  LIGHTING_DASH,
  LIGHTING_DASH_SUCCESS,
  LIGHTING_DASH_ERROR,
  COMPLIANCE_ALERT_REPORT,
  COMPLIANCE_ALERT_REPORT_SUCCESS,
  COMPLIANCE_ALERT_REPORT_ERROR,
  COMPLIANCE_ALERT_DASH,
  COMPLIANCE_ALERT_DASH_SUCCESS,
  COMPLIANCE_ALERT_DASH_ERROR,
  COMPLIANCE_ALERT_LIVE_RECENT,
  COMPLIANCE_ALERT_LIVE_RECENT_SUCCESS,
  COMPLIANCE_ALERT_LIVE_RECENT_ERROR,
  COMPLIANCE_LOG_CHECK_RECENT,
  COMPLIANCE_LOG_CHECK_RECENT_ERROR,
  COMPLIANCE_LOG_CHECK_RECENT_SUCCESS,
  COMPLIANCE_MASK_APPROVE,
  COMPLIANCE_MASK_APPROVE_SUCCESS,
  COMPLIANCE_MASK_APPROVE_ERROR,
  COMPLIANCE_ALERT_UPDATE,
  COMPLIANCE_ALERT_UPDATE_SUCCESS,
  COMPLIANCE_ALERT_UPDATE_ERROR,
  FACILITY_ALERT_REPORT,
  FACILITY_ALERT_REPORT_SUCCESS,
  FACILITY_ALERT_REPORT_ERROR,
  LIGHTING_LOG_REPORT,
  LIGHTING_LOG_REPORT_SUCCESS,
  LIGHTING_LOG_REPORT_ERROR,
  LOG_REPORT_ERROR,
  LOGOUT_USER,
} from "../actions";

export function* watchActionError() {
  yield takeEvery(LOG_REPORT_ERROR, LogReportError);
}

function* LogReportError(message) {
  try {
    if (message.payload.response.status === 401) {
      yield put({ type: LOGOUT_USER });
    }

    yield put({
      type: message.payload.action,
      payload: message.payload.response,
    });
  } catch (error) { }
}

const getLogAsync = async (url, filter_params) =>
  await apiAuth
    .get(url, { params: filter_params })
    .then((Logs) => Logs.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

export function* watchEmployeeLog() {
  yield takeEvery(EMPLOYEE_LOG_REPORT, getEmployeeLog);
}

function* getEmployeeLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/employee/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: EMPLOYEE_LOG_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = EMPLOYEE_LOG_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchEmployeeLogLive() {
  yield takeEvery(GET_EMPLOYEE_LOG_LIVE, getEmployeeLogLive);
}

function* getEmployeeLogLive(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/employee/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: GET_EMPLOYEE_LOG_LIVE_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = GET_EMPLOYEE_LOG_LIVE_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchVisitorLogLive() {
  yield takeEvery(GET_VISITOR_LOG_LIVE, getVisitorLogLive);
}

function* getVisitorLogLive(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/visitor/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: GET_VISITOR_LOG_LIVE_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = GET_VISITOR_LOG_LIVE_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchPeopleCountLog() {
  yield takeEvery(PEOPLE_COUNT_LOG_REPORT, getPeopleCountLog);
}

function* getPeopleCountLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/people_count/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: PEOPLE_COUNT_LOG_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = PEOPLE_COUNT_LOG_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchPeopleTrackLog() {
  yield takeEvery(PEOPLE_TRACK_LOG_REPORT, getPeopleTrackLog);
}

function* getPeopleTrackLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/people_track/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: PEOPLE_TRACK_LOG_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = PEOPLE_TRACK_LOG_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchVehicleCountLog() {
  yield takeEvery(VEHICLE_COUNT_LOG_REPORT, getVehicleCountLog);
}

function* getVehicleCountLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/vehicle_count/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: VEHICLE_COUNT_LOG_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = VEHICLE_COUNT_LOG_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchPeopleCountDash() {
  yield takeEvery(PEOPLE_COUNT_DASH, getPeopleCountDash);
}

function* getPeopleCountDash(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/people_count/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: PEOPLE_COUNT_DASH_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = PEOPLE_COUNT_DASH_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchVehicleCountDash() {
  yield takeEvery(VEHICLE_COUNT_DASH, getVehicleCountDash);
}

function* getVehicleCountDash(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/vehicle_count/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: VEHICLE_COUNT_DASH_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = VEHICLE_COUNT_DASH_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchPeopleOcupancyLog() {
  yield takeEvery(PEOPLE_OCCUPANCY_LOG_REPORT, getPeopleOccupancyLog);
}

function* getPeopleOccupancyLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/people_density/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: PEOPLE_OCCUPANCY_LOG_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = PEOPLE_OCCUPANCY_LOG_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchPeopleOcupancyDash() {
  yield takeEvery(PEOPLE_OCCUPANCY_DASH, getPeopleOccupancyDash);
}

function* getPeopleOccupancyDash(logObj) {
  try {
    let Dashs = yield call(
      getLogAsync,
      "/api/summary/day/people_density/",
      logObj.payload.filter_params
    );

    if (!Dashs.message) {
      yield put({ type: PEOPLE_OCCUPANCY_DASH_SUCCESS, payload: Dashs });
    } else {
      Dashs.message.action = PEOPLE_OCCUPANCY_DASH_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Dashs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchAgeGenderLog() {
  yield takeEvery(AGE_GENDER_LOG_REPORT, getAgeGenderLog);
}

function* getAgeGenderLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/age_gender_emotion/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: AGE_GENDER_LOG_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = AGE_GENDER_LOG_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchAgeGenderDash() {
  yield takeEvery(AGE_GENDER_DASH, getAgeGenderDash);
}

function* getAgeGenderDash(logObj) {
  try {
    let Logs = yield call(
      getLogAsync,
      "/api/summary/day/age_gender_emotion/",
      logObj.payload.filter_params
    );

    Logs = Logs.map((log) => {
      log.emotion_1 = Math.floor(log.emotion_1 / log.records);
      log.emotion_2 = Math.floor(log.emotion_2 / log.records);
      log.emotion_3 = Math.floor(log.emotion_3 / log.records);
      log.emotion_4 = Math.floor(log.emotion_4 / log.records);
      log.emotion_5 = Math.floor(log.emotion_5 / log.records);

      return log;
    });

    if (!Logs.message) {
      yield put({ type: AGE_GENDER_DASH_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = AGE_GENDER_DASH_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchANPRLog() {
  yield takeEvery(ANPR_REPORT, getANPRLog);
}

function* getANPRLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/anpr/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: ANPR_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = ANPR_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchADDANPRLog() {
  yield takeEvery(ADD_ANPR_REPORT, addReport);
}

const addANPRAsync = async (anpr) =>
  await apiAuth
    .post("/api/log/anpr/", anpr)
    .then((anprs) => anprs.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* addReport(anprObj) {
  try {
    const anpr = yield call(addANPRAsync, anprObj.payload);
    if (!anpr.message) {
      yield put({ type: ADD_ANPR_REPORT_SUCCESS, payload: anpr });
    } else {
      anpr.message.action = ADD_ANPR_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: anpr.message });
    }
  } catch (error) {
    yield put({ type: ADD_ANPR_REPORT_ERROR, payload: error });
  }
}
export function* watchANPRLiveLog() {
  yield takeEvery(ANPR_LIVE_REPORT, getANPRLiveLog);
}

function* getANPRLiveLog(livelogObj) {
  try {
    const LiveLogs = yield call(
      getLogAsync,
      "/api/log/anpr/",
      livelogObj.payload
    );
    if (!LiveLogs.message) {
      yield put({ type: ANPR_LIVE_REPORT_SUCCESS, payload: LiveLogs });
    } else {
      LiveLogs.message.action = ANPR_LIVE_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: LiveLogs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchANPRSearchLog() {
  yield takeEvery(ANPR_SEARCH_REPORT, getANPRSearchLog);
}

function* getANPRSearchLog(searchLogObj) {
  console.log("searchLogObj ==>>", searchLogObj)
  try {
    const SearchLogs = yield call(
      getLogAsync,
      "/api/log/anpr/",
      searchLogObj.payload
    );
    if (!SearchLogs.message) {
      yield put({ type: ANPR_SEARCH_REPORT_SUCCESS, payload: SearchLogs });
    } else {
      SearchLogs.message.action = ANPR_SEARCH_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: SearchLogs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}




export function* watchVehicleLiveParking() {
  yield takeEvery(VEHICLE_LIVE_PARKING, getVehicleLiveParking);
}

function* getVehicleLiveParking(parkingObj) {
  
  try {
    const ParkingLogs = yield call(
      getLogAsync,
      "/api/log/car_parking/",
      parkingObj.payload
    );
    if (!ParkingLogs.message) {
      yield put({ type: VEHICLE_LIVE_PARKING_SUCCESS, payload: ParkingLogs });
    } else {
      ParkingLogs.message.action = VEHICLE_LIVE_PARKING_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: ParkingLogs.message });
    }
  } catch (error) {
    yield put({ type: VEHICLE_LIVE_PARKING_ERROR, payload: error });
  }
}

export function* watchANPRDash() {
  yield takeEvery(ANPR_DASH, getANPRDash);
}

function* getANPRDash(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/anpr/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: ANPR_DASH_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = ANPR_DASH_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchParkingLog() {
  yield takeEvery(PARKING_LOG_REPORT, getParkingLog);
}

function* getParkingLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/car_parking/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: PARKING_LOG_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = PARKING_LOG_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchParkingDash() {
  yield takeEvery(PARKING_DASH, getParkingDash);
}

function* getParkingDash(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/summary/day/car_parking/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: PARKING_DASH_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = PARKING_DASH_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchLightingLog() {
  yield takeEvery(LIGHTING_LOG_REPORT, getLightingLog);
}

function* getLightingLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/lights/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: LIGHTING_LOG_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = LIGHTING_LOG_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchLightingDash() {
  yield takeEvery(LIGHTING_DASH, getLightingDash);
}

function* getLightingDash(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/log/lights/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: LIGHTING_DASH_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = LIGHTING_DASH_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchComplianceLog() {
  yield takeEvery(COMPLIANCE_ALERT_REPORT, getComplainceLog);
}

function* getComplainceLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/alert/compliance/view/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: COMPLIANCE_ALERT_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = COMPLIANCE_ALERT_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchComplianceDash() {
  yield takeEvery(COMPLIANCE_ALERT_DASH, getComplainceDash);
}

function* getComplainceDash(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/summary/day/compliance/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: COMPLIANCE_ALERT_DASH_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = COMPLIANCE_ALERT_DASH_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchComplianceRecent() {
  yield takeEvery(COMPLIANCE_ALERT_LIVE_RECENT, getComplainceRecent);
}

function* getComplainceRecent(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/alert/compliance/view/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: COMPLIANCE_ALERT_LIVE_RECENT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = COMPLIANCE_ALERT_LIVE_RECENT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchComplianceCheck() {
  yield takeEvery(COMPLIANCE_LOG_CHECK_RECENT, getComplainceCheck);
}

function* getComplainceCheck(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/alert/compliance/view/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: COMPLIANCE_LOG_CHECK_RECENT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = COMPLIANCE_LOG_CHECK_RECENT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

export function* watchFacilityAlertLog() {
  yield takeEvery(FACILITY_ALERT_REPORT, getFacilityAlertLog);
}

function* getFacilityAlertLog(logObj) {
  try {
    const Logs = yield call(
      getLogAsync,
      "/api/alert/faclity/view/",
      logObj.payload.filter_params
    );

    if (!Logs.message) {
      yield put({ type: FACILITY_ALERT_REPORT_SUCCESS, payload: Logs });
    } else {
      Logs.message.action = FACILITY_ALERT_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: Logs.message });
    }
  } catch (error) {
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

function* watchApproveCompliance() {
  yield takeEvery(COMPLIANCE_MASK_APPROVE, approveCompliance);
}

const approveComplianceAsync = async (alert) =>
  await apiAuth
    .patch(`/api/alert/compliance/update/${alert.id}/`, {
      approved: true,
      description: alert.description,
    })
    .then((complaince) => complaince.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

const approveComplianceFailAsync = async (alert) =>
  await apiAuth
    .patch(`/api/alert/compliance/update/${alert.id}/`, {
      approved: false,
      description: alert.description,
    })
    .then((complaince) => complaince.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

const approveComplianceFailNoFaceAsync = async (alert) =>
  await apiAuth
    .patch(`/api/alert/compliance/update/${alert.id}/`, {
      approved: false,
      description: { type: "NoFace" },
    })
    .then((complaince) => complaince.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

const approveComplianceDuplicateAsync = async (alert) =>
  await apiAuth
    .delete(`/api/alert/compliance/update/${alert.id}/`)
    .then((complaince) => complaince)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* approveCompliance(complainceobj) {
  try {
    console.log(complainceobj);
    if (complainceobj.payload.mode === "approve") {
      const complaince = yield call(
        approveComplianceAsync,
        complainceobj.payload.data
      );
      console.log("alert log");
      console.log(complainceobj.payload.data);
      if (!complaince.message) {
        console.log("alert log approve success");
        NotificationManager.success(
          '',
          'Alert Updated Success',
          3000,
          null,
          null,
          ""
        );
        yield put({
          type: COMPLIANCE_MASK_APPROVE_SUCCESS,
          payload: complainceobj.payload.data,
        });
      } else {
        complaince.message.action = COMPLIANCE_MASK_APPROVE_ERROR;
        yield put({ type: LOG_REPORT_ERROR, payload: complaince.message });
      }
    } else if (complainceobj.payload.mode === "notApprove") {
      const complaince = yield call(
        approveComplianceFailAsync,
        complainceobj.payload.data
      );
      console.log("alert log");
      console.log(complainceobj.payload.data);
      if (!complaince.message) {
        console.log("alert log approve success");
        yield put({
          type: COMPLIANCE_MASK_APPROVE_SUCCESS,
          payload: complainceobj.payload.data,
        });
      } else {
        complaince.message.action = COMPLIANCE_MASK_APPROVE_ERROR;
        yield put({ type: LOG_REPORT_ERROR, payload: complaince.message });
      }
    } else if (complainceobj.payload.mode === "notFace") {
      const complaince = yield call(
        approveComplianceFailNoFaceAsync,
        complainceobj.payload.data
      );
      console.log("alert log");
      console.log(complainceobj.payload.data);
      if (!complaince.message) {
        console.log("alert log approve success");
        yield put({
          type: COMPLIANCE_MASK_APPROVE_SUCCESS,
          payload: complainceobj.payload.data,
        });
      } else {
        complaince.message.action = COMPLIANCE_MASK_APPROVE_ERROR;
        yield put({ type: LOG_REPORT_ERROR, payload: complaince.message });
      }
    } else if (complainceobj.payload.mode === "duplicate") {
      const complaince = yield call(
        approveComplianceDuplicateAsync,
        complainceobj.payload.data
      );
      console.log("alert log duplicate");
      console.log(complainceobj.payload.data);
      if (!complaince.message) {
        console.log("alert log approve success");
        yield put({
          type: COMPLIANCE_MASK_APPROVE_SUCCESS,
          payload: complainceobj.payload.data,
        });
      } else {
        complaince.message.action = COMPLIANCE_MASK_APPROVE_ERROR;
        yield put({ type: LOG_REPORT_ERROR, payload: complaince.message });
      }
    }
  } catch (error) {
    console.log(error);
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}







export function* watchUpdateCompliance() {
  yield takeEvery(COMPLIANCE_ALERT_UPDATE, updateCompliance);
}

function* updateCompliance(complianceObj) {
  try {
    console.log("complianceObj ==>>", complianceObj);
    const complaince = yield call(
      updateComplianceAsync,
      complianceObj.payload.data
    );

    if (!complaince.message) {
      console.log("complaince update success");
      NotificationManager.success(
        '',
        'Alert Updated Success',
        3000,
        null,
        null,
        ""
      );
      yield put({
        type: COMPLIANCE_ALERT_UPDATE_SUCCESS,
        payload: complianceObj.payload.data,
      });
    } else {
      complaince.message.action = COMPLIANCE_ALERT_UPDATE_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: complaince.message });
    }
  } catch (error) {
    console.log(error);
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

const updateComplianceAsync = async (alert) =>
  await apiAuth
    .patch(`/api/alert/compliance/update/${alert.id}/`, {
      description: alert.description,
    })
    .then((complaince) => complaince.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

export function* watchUpdateANPRLiveLog() {
  yield takeEvery(UPDATE_ANPR_REPORT, updateReport);
}

function* updateReport(reportObj) {
  try {
    console.log("reportObj ==>>", reportObj);
    const report = yield call(
      updateReportAsync,
      reportObj.payload
    );

    if (!report.message) {
      NotificationManager.success(
        '',
        'Report Updated Success',
        3000,
        null,
        null,
        ""
      );
      yield put({
        type: UPDATE_ANPR_REPORT_SUCCESS,
        payload: reportObj.payload,
      });
    } else {
      report.message.action = UPDATE_ANPR_REPORT_ERROR;
      yield put({ type: LOG_REPORT_ERROR, payload: report.message });
    }
  } catch (error) {
    console.log(error);
    yield put({ type: LOG_REPORT_ERROR, payload: error });
  }
}

const updateReportAsync = async (report) =>
  await apiAuth
    .patch(`/api/log/anpr/${report.id}/`, report.data)
    .then((complaince) => complaince.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

export default function* rootSaga() {
  yield all([fork(watchActionError)]);
  yield all([fork(watchPeopleCountDash)]);
  yield all([fork(watchEmployeeLog)]);
  yield all([fork(watchPeopleCountLog)]);
  yield all([fork(watchPeopleTrackLog)]);
  yield all([fork(watchPeopleOcupancyLog)]);
  yield all([fork(watchPeopleOcupancyDash)]);
  yield all([fork(watchAgeGenderLog)]);
  yield all([fork(watchAgeGenderDash)]);
  yield all([fork(watchANPRLog)]);
  yield all([fork(watchADDANPRLog)]);
  yield all([fork(watchANPRLiveLog)]);
  yield all([fork(watchANPRSearchLog)]);
  yield all([fork(watchVehicleLiveParking)]);
  yield all([fork(watchUpdateANPRLiveLog)]);
  yield all([fork(watchANPRDash)]);
  yield all([fork(watchParkingLog)]);
  yield all([fork(watchParkingDash)]);
  yield all([fork(watchLightingLog)]);
  yield all([fork(watchLightingDash)]);
  yield all([fork(watchComplianceLog)]);
  yield all([fork(watchComplianceDash)]);
  yield all([fork(watchComplianceRecent)]);
  yield all([fork(watchUpdateCompliance)]);
  yield all([fork(watchFacilityAlertLog)]);
  yield all([fork(watchEmployeeLogLive)]);
  yield all([fork(watchVisitorLogLive)]);
  yield all([fork(watchComplianceCheck)]);
  yield all([fork(watchApproveCompliance)]);
  yield all([fork(watchVehicleCountDash)]);
  yield all([fork(watchVehicleCountLog)]);
}
